import { useState, useEffect } from 'react';
import { useApi } from '../../../hooks/use-api';
import { moduleClientFactory } from '../../../api-service/module-client-factory';
import { ITeamLookup } from './interfaces';

export const useFetch = (input: string, fetchMinimumInputLength: number, includeInactiveTeams: boolean, initialValue?: ITeamLookup[]) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [data, setData] = useState<ITeamLookup[]>(initialValue || []);

  const client = moduleClientFactory.createLookupTeamClient();
  const usersLookupApi = useApi((cancelToken, query: string) => client.getTeamsByLookupQuery({ query, includeInactiveTeams }, cancelToken), { teams: [] });

  useEffect(() => {
    if (input.length >= fetchMinimumInputLength) {
      setLoading(true);
      const search = async () => {
        try {
          const response = await usersLookupApi.invoke(input);
          setData(response.result.teams || []);
        } catch (err: any) {
          setError(err);
        } finally {
          setLoading(false);
        }
      };
      search();
    } else {
      setData(initialValue || []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input]);

  return { loading, data, error };
};
